export const COLOR = { PRIMER: "#9b3789" };